import { PropsWithChildren } from 'react';
import { useHasPermission } from '@hooks/use-has-permission';
import { Permission } from '@common/utils/admin_permissions';

export const BasePermission = ({ children }: PropsWithChildren) => {
  const hasBasePermission = useHasPermission([Permission.ADMIN_APP_READ]);

  if (!hasBasePermission && USER_PORTAL_URL) {
    window.location.replace(USER_PORTAL_URL);
    return;
  }

  return <>{children}</>;
};
